import { isSSR } from "./ssr";

export const isPrintMedia = () => {
  if (isSSR()) return false;

  return window.matchMedia(`print`).matches;
};
